import { makeStyles } from '@material-ui/styles'
import SimpleLink from 'core/components/SimpleLink'
import Text from 'core/elements/Text'
import { toPairs } from 'ramda'
import React from 'react'

const useStyles = makeStyles((theme) => ({
  labelsContainer: {
    display: 'grid',
    gridTemplateRows: 'max-content',
    gridGap: 4,
  },
  label: {
    display: 'grid',
    gridTemplateColumns: 'max-content 1fr',
    gridGap: theme.spacing(2),
    '& > span': {
      whiteSpace: 'nowrap',
      textOverflow: 'ellipsis',
      overflow: 'hidden',
      margin: 0,
    },
    '& b': {
      fontWeight: 600,
    },
  },
  value: {
    display: 'block',
    wordBreak: 'break-word',
  },
}))

const getLabelValue = (value) =>
  Array.isArray(value)
    ? value.length
    : typeof value === 'object'
    ? Object.keys(value).length
    : value

export const RenderLabels = ({
  variant = 'body2',
  labels,
  link = null,
  showLinkLabelNameArray = [],
  keyOverrides = undefined,
  inverse = false,
  split = false,
}) => {
  const classes = useStyles({ split, inverse })
  return (
    <div className={classes.labelsContainer}>
      {toPairs(labels).map(([name, value]) => {
        const labelValue = getLabelValue(value)
        const formattedName = !!keyOverrides && keyOverrides[name] ? keyOverrides[name] : name
        const showLink = showLinkLabelNameArray.includes(formattedName)
        return (
          <div className={classes.label} key={name}>
            {inverse ? (
              <Text component="span" variant={variant}>
                {formattedName}:
              </Text>
            ) : (
              <Text component="span" variant={variant}>
                <b>{formattedName}:</b>
              </Text>
            )}
            {showLink ? (
              inverse ? (
                <Text component="span" variant={variant} className={classes.value}>
                  <b>
                    <SimpleLink src={link}>{labelValue || 'N/A'} </SimpleLink>
                  </b>
                </Text>
              ) : (
                <Text component="span" variant={variant} className={classes.value}>
                  <SimpleLink src={link}>{labelValue || 'N/A'} </SimpleLink>
                </Text>
              )
            ) : inverse ? (
              <Text component="span" variant={variant} className={classes.value}>
                <b>{labelValue || 'N/A'}</b>
              </Text>
            ) : (
              <Text component="span" variant={variant} className={classes.value}>
                {labelValue || 'N/A'}
              </Text>
            )}
          </div>
        )
      })}
    </div>
  )
}

const renderLabels = (type, variant, link = null, showLinkLabelNameArray = []) => (labels) => (
  <RenderLabels
    variant={variant}
    labels={labels}
    link={link}
    showLinkLabelNameArray={showLinkLabelNameArray}
  />
)

export default renderLabels
